import { createAction } from '@lingoda/core';
import type { StudentInfo } from '../models';

export default createAction<StudentInfo>('studentInfo/ADD_STUDENT_INFO');
